import type { ReactElement } from 'react';

import { LegalPage } from '~/components/pages/LegalPage';

function Page(): ReactElement {
  return <LegalPage pageKey="terms" />;
}

export { Page };
